export type { TableConfiguration } from '../../services/table-configuration.service';
export { TableConfigurationService } from '../../services/table-configuration.service';
export type { TableConfigurationSource } from '../../services/table-configuration.service';
